import { call, put, takeEvery } from 'redux-saga/effects';
import * as actions from './customViewActions';
import * as types from './customViewActionType';
import * as services from './customViewServices';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';

// Fetch Custom Views Saga
function* fetchCustomViewsSaga(action) {
    try {
        const response = yield call(services.fetchCustomViewsAPI, action.payload);
        if (response?.success || response?.values) {
            yield put(actions.fetchCustomViewsSuccess(response));
        } else {
            yield put(actions.fetchCustomViewsFailure('No data found'));
        }
    } catch (error) {
        console.error('Custom Views Fetch Error:', error);
        yield put(actions.fetchCustomViewsFailure(error.message || 'Failed to fetch custom views'));
    }
}

// Toggle Custom View Status Saga
function* toggleCustomViewStatusSaga(action) {
    try {
        const response = yield call(services.toggleCustomViewStatusAPI, action.payload);
        if (response?.success) {
            yield put(actions.toggleCustomViewStatusSuccess({
                ...response,
                toggledItem: {
                    RadiologistCustomViewID: action.payload.Id,
                    IsActive: action.payload.Status
                }
            }));

            // Refresh the custom views list to ensure data consistency with backend
            yield put(actions.fetchCustomViewsRequest({ UserID: action.payload.UserId }));

            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Status updated successfully.'
            });
        } else {
            yield put(actions.toggleCustomViewStatusFailure('Failed to update status'));

            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to update status.'
            });
        }
    } catch (error) {
        console.error('Toggle Custom View Status Error:', error);
        yield put(actions.toggleCustomViewStatusFailure(error.message || 'Failed to update status'));
    }
}

// Delete Custom View Saga
function* deleteCustomViewSaga(action) {
    try {
        const response = yield call(services.deleteCustomViewAPI, action.payload);
        if (response?.success) {
            yield put(actions.deleteCustomViewSuccess(response));
            // Refresh the list after successful deletion
            yield put(actions.fetchCustomViewsRequest({ UserID: action.payload.UserID }));

             SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Status updated successfully.'
            });
        } else {
            yield put(actions.deleteCustomViewFailure('Failed to delete custom view'));

            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to update status.'
            });
        }
    } catch (error) {
        console.error('Delete Custom View Error:', error);
        yield put(actions.deleteCustomViewFailure(error.message || 'Failed to delete custom view'));
    }
}

// Fetch Rad Custom View Saga
function* fetchRadCustomViewSaga(action) {
    try {
        const response = yield call(services.fetchRadCustomViewAPI, action.payload);
        if (response?.success || response?.values) {
            const data = {
                fieldValues: response.values?.fieldValues || [],
                fieldName: response.values?.fieldName || []
            };
            yield put(actions.fetchRadCustomViewSuccess(data));
        } else {
            yield put(actions.fetchRadCustomViewFailure('No data found'));
        }
    } catch (error) {
        console.error('Rad Custom View Fetch Error:', error);
        yield put(actions.fetchRadCustomViewFailure(error.message || 'Failed to fetch provider custom view'));
    }
}

// Fetch Custom View Share Dropdown in AddRadCustomViewModal Saga
function* fetchCustomViewShareDropdownSaga(action) {
    try {
        const response = yield call(services.fetchCustomViewShareDropdownAPI, action.payload);
        if (response?.success || response?.values) {
            const dropdownData = response.values?.dropdownListModel || [];
            const sharedListData = response.values?.sharedViewList || [];

            // Dispatch success for both dropdown and shared list
            yield put(actions.fetchCustomViewShareDropdownSuccess({
                dropdownData,
                sharedListData
            }));
        } else {
            yield put(actions.fetchCustomViewShareDropdownFailure('No data found'));
        }
    } catch (error) {
        console.error('Custom View Share Data Fetch Error:', error);
        yield put(actions.fetchCustomViewShareDropdownFailure(error.message || 'Failed to fetch data'));
    }
}

// Save Shared Custom View Saga
function* saveSharedCustomViewSaga(action) {
    try {
        const response = yield call(services.saveSharedCustomViewAPI, action.payload);
        if (response?.success) {
            yield put(actions.saveSharedCustomViewSuccess(response));
            // Refresh the shared list after successful save
            yield put(actions.fetchCustomViewShareDropdownRequest({
                ViewId: action.payload.ViewId,
                LoginUserId: action.payload.LoginUserId
            }));
        } else {
            yield put(actions.saveSharedCustomViewFailure(response?.errorMessage || 'Failed to save shared custom view'));
        }
    } catch (error) {
        console.error('Save Shared Custom View Error:', error);
        yield put(actions.saveSharedCustomViewFailure(error.message || 'Failed to save shared custom view'));
    }
}
// Fetch Provider All DD List Saga
function* fetchRadiologistAllDDListSaga() {
    try {
        const response = yield call(services.fetchRadiologistAllDDListAPI);

        if (response?.success && response?.values) {
            yield put(
                actions.getRadiologistAllDDListSuccess(response.values)
            );
        } else {
            yield put(
                actions.getRadiologistAllDDListFailure('No data found')
            );
        }
    } catch (error) {
        yield put(
            actions.getRadiologistAllDDListFailure(
                error.message || 'Failed to fetch Provider DD list'
            )
        );
    }
}
export function* saveRadCustomViewSaga(action) {
    try {
        const response = yield call(
            services.saveRadiologistCustomViewAPI,
            action.payload
        );

        if (response?.success) {
            yield put(actions.saveRadCustomViewSuccess(response));
            
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Successfully Saved Provider Custom View.'
            });
        } else {
            yield put(
                actions.saveRadCustomViewFailure(
                    response?.errorMessage || 'Save failed'
                )
            );
            
            SweetAlert.error({
                title: 'Oops',
                text: response?.errorMessage || 'Failed to save Provider Custom View.'
            });
        }
    } catch (error) {
        yield put(
            actions.saveRadCustomViewFailure(
                error.message || 'Save failed'
            )
        );
        
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to save Provider Custom View.'
        });
    }
}
export default function* customViewSaga() {
    yield takeEvery(types.FETCH_CUSTOM_VIEWS_REQUEST, fetchCustomViewsSaga);
    yield takeEvery(types.DELETE_CUSTOM_VIEW_REQUEST, deleteCustomViewSaga);
    yield takeEvery(types.TOGGLE_CUSTOM_VIEW_STATUS_REQUEST, toggleCustomViewStatusSaga);
    yield takeEvery(types.FETCH_RAD_CUSTOM_VIEW_REQUEST, fetchRadCustomViewSaga);
    yield takeEvery(types.FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_REQUEST, fetchCustomViewShareDropdownSaga);
    yield takeEvery(types.SAVE_SHARED_CUSTOM_VIEW_REQUEST, saveSharedCustomViewSaga);
     yield takeEvery(types.GET_RADIOLOGIST_ALL_DD_LIST_REQUEST, fetchRadiologistAllDDListSaga);
    yield takeEvery(types.SAVE_RAD_CUSTOM_VIEW_REQUEST, saveRadCustomViewSaga);
}

